export const PLATFORM_TIME_ZONE_LABEL = '北京时间（UTC+8）';

const PLATFORM_TIME_ZONE = 'Asia/Shanghai';
const SQL_DATE_TIME_PATTERN = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/;
const EXPLICIT_TIME_ZONE_PATTERN = /(Z|[+-]\d{2}:?\d{2})$/i;

export function formatPlatformTime(value?: string, includeSeconds = false) {
  if (!value) return '-';
  const text = String(value).trim();
  const sqlParts = text.match(SQL_DATE_TIME_PATTERN);

  // MySQL DATETIME values are already platform clock time and have no zone.
  if (sqlParts && !EXPLICIT_TIME_ZONE_PATTERN.test(text)) {
    const [, year, month, day, hour, minute, second] = sqlParts;
    return `${year}-${month}-${day} ${hour}:${minute}${includeSeconds ? `:${second}` : ''}`;
  }

  const date = new Date(text);
  if (Number.isNaN(date.getTime())) return text;
  const parts = new Intl.DateTimeFormat('zh-CN', {
    timeZone: PLATFORM_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: includeSeconds ? '2-digit' : undefined,
    hourCycle: 'h23',
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day} ${values.hour}:${values.minute}${includeSeconds ? `:${values.second}` : ''}`;
}
